<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && Object.keys(userMacInfo).length===0">{{ $t('gateway.no_gateway_available_hint' )}}</span>

  <span class="centerized title grey--text text-xs-center" v-else-if="!loading && filteredMac.length===0">{{ $t('gateway.no_gateway_matched' )}}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xs12 sm6 md4 lg4 xl3 v-for="mac in filteredMac" :key="mac.mac">
      <gateway-compact-item :data="mac" :itemCommands="itemCommands" @detail="onGatewayDetail" @edit="onGatewayEdit" @toast="val=>$emit('toast',val)"></gateway-compact-item>
    </v-flex>
  </v-layout>

  <v-btn color="secondary" dark fixed bottom right fab @click="dialogAuthCode=true" v-if="!loading">
    <v-icon>add</v-icon>
  </v-btn>

  <gateway-chart v-if="dialogChart" v-model="dialogChart" :mac="dialogChartMac" :type="dialogChartType" :name="dialogChartName"></gateway-chart>

  <gateway-authcode v-if="dialogAuthCode" v-model="dialogAuthCode" @done="onGatewayBound"></gateway-authcode>

  <gateway-detail-item v-if="dialogDetail" v-model="dialogDetail" :data="dialogDetailData" :itemCommands="itemCommands" @edit="dialogDetail=false;dialogEditor=true" @toast="val=>$emit('toast',val)"></gateway-detail-item>

  <gateway-editor v-if="dialogEditor" v-model="dialogEditor" :data="dialogDetailData" @toast="val=>$emit('toast',val)"></gateway-editor>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import GatewayCompactItem from './GatewayCompactItem'
import GatewayDetailItem from './GatewayDetailItem'
import GatewayAuthCode from './GatewayAuthCode'
import GatewayChart from './GatewayChart'
import GatewayEditorDialog from './GatewayEditorDialog'

export default {
  name: 'Gateway',
  mixins: [UserAuth],
  components: {
    'gateway-compact-item': GatewayCompactItem,
    'gateway-detail-item': GatewayDetailItem,
    'gateway-authcode': GatewayAuthCode,
    'gateway-chart': GatewayChart,
    'gateway-editor': GatewayEditorDialog
  },
  data() {
    return {
      itemCommands: {
        load: data => {
          this.dialogChartType = 'load';
          this.dialogChartMac = data.mac;
          this.dialogChartName = data.hostname;
          this.dialogChart = true;
        },
        free_memory: data => {
          this.dialogChartType = 'memory';
          this.dialogChartMac = data.mac;
          this.dialogChartName = data.hostname;
          this.dialogChart = true;
        },
        latency: data => {
          this.dialogChartType = 'latency';
          this.dialogChartMac = data.mac;
          this.dialogChartName = data.hostname;
          this.dialogChart = true;
        }
      },
      dialogChart: false,
      dialogChartType: 'load',
      dialogChartMac: null,
      dialogChartName: null,
      dialogAuthCode: false,
      dialogDetail: false,
      dialogDetailMac: null,
      dialogEditor: false
    }
  },
  computed: {
    loading() {
      return this.macInfoLoading;
    },
    filteredMac() {
      let data = Object.values(this.userMacInfo);
      if (data && this.searchKeyword)
        data = data.filter(item => [
          item.mac,
          item.uuid || '',
          item.address || '',
          item.hostname || '',
          item.map || '',
          (item.firmware || {}).version || ''
        ].join('#').toLowerCase().indexOf(this.searchKeyword.toLowerCase()) != -1);
      return data;
    },
    dialogDetailData() {
      return this.userMacInfo[this.dialogDetailMac];
    }
  },
  methods: {
    onGatewayBound(mac) {
      this.dialogAuthCode = false;
      this.$emit('toast', this.$t('gateway.get_gateway_ready', {
        mac: (this.userMacInfo[mac] || {}).hostname || mac
      }));
    },
    onGatewayDetail(mac) {
      this.dialogDetailMac = mac;
      this.dialogDetail = true;
    },
    onGatewayEdit(mac) {
      this.dialogDetailMac = mac;
      this.dialogEditor = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/Gateway.vue